import { render } from "./WoolPriceCheck.vue?vue&type=template&id=5d93488e"
import script from "./WoolPriceCheck.vue?vue&type=script&lang=js"
export * from "./WoolPriceCheck.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__